export default __webpack_public_path__ + "static/media/CW__3558.2d27bb92.jpg";